/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, number, bool, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { compose } from 'recompose';

import DesktopAccountSocialLogin from './DesktopAccountSocialLogin/DesktopAccountSocialLogin';
import DesktopAccountUserProfile from './DesktopAccountUserProfile/DesktopAccountUserProfile';
import DesktopAccountBillingAddress from './DesktopAccountBillingAddress/DesktopAccountBillingAddress';
import DesktopAccountPaymentMethod from './DesktopAccountPaymentMethod/DesktopAccountPaymentMethod';
import DesktopAccountEmailpreference from './DesktopAccountEmailPreference/DesktopAccountEmailPreference';
import DesktopAccountRecentOrders from './DesktopAccountRecentOrders/DesktopAccountRecentOrders';
import { trackPage } from '../../../../../helpers/tracking/common/commonTrackingHelpers';
class DesktopAccountHome extends PureComponent {
    render() {
        const {
            userProfile, featureFlags,
        } = this.props;
        const connectWithDisabled = (featureFlags?.['app-standalone-account-hide-links'] || []).includes?.("connect_section");
        const optInOutDisabled = (featureFlags?.['app-standalone-account-hide-links'] || []).includes?.("/account/email-preference");
        return (
            <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                  <h2>ACCOUNT OVERVIEW </h2>
                  <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                     <Grid className="block position-relative" item xs={4}>
                        <div role="heading" aria-level="2" className="blockHeader">Payment Methods </div>
                        <DesktopAccountPaymentMethod />
                     </Grid>
                     <Grid className="block position-relative" item xs={4}>
                        <div role="heading" aria-level="2" className="blockHeader">Billing Addresses</div>
                        <DesktopAccountBillingAddress />
                     </Grid>
                     <Grid className="block position-relative" item xs={4}>
                        <div role="heading" aria-level="2" className="blockHeader">Recent Orders </div>
                        <DesktopAccountRecentOrders userProfile={userProfile} featureFlags={featureFlags} />
                     </Grid>
                  </Grid>
                <Grid className="shadowContentGrid contentGrid" container item xs={optInOutDisabled ? 6 : 12}>
                    {!connectWithDisabled && <Grid className="block position-relative" item xs={4}>
                        <div role="heading" aria-level="2" className="blockHeader">Connect with </div>
                        <DesktopAccountSocialLogin />
                    </Grid>}
                    <Grid className="block position-relative" item xs={connectWithDisabled ? 6 * (optInOutDisabled ? 2 : 1) : 4}>
                        <div role="heading" aria-level="2" className="blockHeader">Profile</div>
                        <DesktopAccountUserProfile userProfile={userProfile} />
                    </Grid>

                    {!optInOutDisabled && <Grid className="block position-relative" item xs={connectWithDisabled ? 6 : 4}>
                        <div role="heading" aria-level="2" className="blockHeader">Email Preferences </div>
                        <DesktopAccountEmailpreference userProfile={userProfile} />
                     </Grid>}
                  </Grid>
            </Grid>
        );
    }
}

DesktopAccountHome.propTypes = {
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object.isRequired,
};

const enhance = compose(
    trackPage({
        type: 'myaccount',
        name: 'MyAccount',
        accountPage: true,
    }),
);
export default enhance(DesktopAccountHome);

